
import React from 'react';
import { useSupabaseAuth } from '@/hooks/auth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

const AuthStatus: React.FC = () => {
  const { session, user, profile, userRole, isLoading, signOut } = useSupabaseAuth();

  if (isLoading) {
    return <div>Loading auth status...</div>;
  }

  return (
    <Card className="max-w-md mx-auto">
      <CardHeader>
        <CardTitle>Authentication Status</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <strong>Session:</strong> {session ? '✅ Active' : '❌ None'}
        </div>
        <div>
          <strong>User:</strong> {user ? `✅ ${user.email}` : '❌ None'}
        </div>
        <div>
          <strong>Profile:</strong> {profile ? `✅ ${profile.name}` : '❌ None'}
        </div>
        <div>
          <strong>Role:</strong> {userRole ? <Badge variant="outline">{userRole}</Badge> : '❌ None'}
        </div>
        <div>
          <strong>Approved:</strong> {profile?.is_approved ? '✅ Yes' : '❌ No'}
        </div>
        {session && (
          <Button onClick={signOut} variant="outline" className="w-full">
            Sign Out
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default AuthStatus;
